 $(document).ready(function () {
  $('.scroll-link').click(function (event) {
    event.preventDefault();
    var targetId = $(this).attr('href');
    var targetElement = $(targetId);
    var headerHeight = $('sticky-header.header-wrapper').outerHeight() + 10;

    if (targetElement.length) {
      $('html, body').animate({
        scrollTop: targetElement.offset().top - headerHeight
      }, 800);
    }
  });
});
